import React from "react";
import { AiOutlineClose, AiOutlineUser, AiOutlineSafety, AiOutlineTeam, AiOutlineLock } from "react-icons/ai";
import useUser from "../hooks/useUser";
import { formatDateTime } from "../utils/dateUtils";

const UserDataModal = ({ isOpen, onClose, userData }) => {
  const { roles, groups, clearances, effectiveClearance } = useUser();
  
  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <div style={styles.titleContainer}>
            <AiOutlineUser size={24} style={styles.icon} />
            <h2 style={styles.title}>Datos Personales</h2>
          </div>
          <button
            onClick={onClose}
            style={styles.closeButton}
            title="Cerrar"
          >
            <AiOutlineClose size={20} />
          </button>
        </div>

        <div style={styles.content}>
          {userData ? (
            <div style={styles.userInfo}>
              {/* Debug info */}
              {/*<div style={styles.field}>
                <label style={styles.label}>Debug - Datos completos:</label>
                <pre style={styles.debugValue}>
                  {JSON.stringify(userData, null, 2)}
                </pre>
              </div>*/}
              
              {/*<div style={styles.field}>
                <label style={styles.label}>ID de usuario:</label>
                <span style={styles.value}>{userData.profile.sub || 'N/A'}</span>
              </div>*/}
              
              <div style={styles.field}>
                <label style={styles.label}>Nombre de usuario:</label>
                <span style={styles.value}>{userData.profile.preferred_username || userData.profile.sub || 'N/A'}</span>
              </div>

              {userData.profile.given_name && (
                <div style={styles.field}>
                  <label style={styles.label}>Nombre:</label>
                  <span style={styles.value}>{userData.profile.given_name}</span>
                </div>
              )}
              
              {userData.profile.family_name && (
                <div style={styles.field}>
                  <label style={styles.label}>Apellido:</label>
                  <span style={styles.value}>{userData.profile.family_name}</span>
                </div>
              )}
              
              <div style={styles.field}>
                <label style={styles.label}>Email:</label>
                <span style={styles.value}>{userData.profile.email || 'N/A'}</span>
              </div>
              
              <div style={styles.field}>
                <label style={styles.label}>Email verificado:</label>
                <span style={styles.value}>
                  {userData.profile.email_verified ? 'Sí' : 'No'}
                </span>
              </div>
              
              {/*<div style={styles.field}>
                <label style={styles.label}>Fecha de autenticación:</label>
                <span style={styles.value}>
                  {userData.auth_time ? formatDateTime(userData.profile.iat * 1000, { placeholder: 'N/A' }) : 'N/A'}
                </span>
              </div>*/}

              <div style={styles.field}>
                <label style={styles.label}>Fecha de expiración:</label>
                <span style={styles.value}>
                  {userData.auth_time ? formatDateTime(userData.expires_at * 1000, { placeholder: 'N/A' }) : 'N/A'}
                </span>
              </div>
              
              {/* Sección de Roles */}
              <div style={styles.section}>
                <div style={styles.sectionHeader}>
                  <AiOutlineSafety style={styles.sectionIcon} />
                  <h3 style={styles.sectionTitle}>Roles</h3>
                </div>
                {roles.length > 0 ? (
                  <div style={styles.tagContainer}>
                    {roles.map((role, index) => (
                      <span key={index} style={styles.tag}>
                        {role}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span style={styles.noData}>No tiene roles asignados</span>
                )}
              </div>

              {/* Sección de Grupos */}
              <div style={styles.section}>
                <div style={styles.sectionHeader}>
                  <AiOutlineTeam style={styles.sectionIcon} />
                  <h3 style={styles.sectionTitle}>Grupos</h3>
                </div>
                {groups.length > 0 ? (
                  <div style={styles.tagContainer}>
                    {groups.map((group, index) => (
                      <span key={index} style={styles.tag}>
                        {group}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span style={styles.noData}>No pertenece a ningún grupo</span>
                )}
              </div>

              {/* Sección de Clearances */}
              <div style={styles.section}>
                <div style={styles.sectionHeader}>
                  <AiOutlineLock style={styles.sectionIcon} />
                  <h3 style={styles.sectionTitle}>Niveles de Acceso</h3>
                </div>
                {clearances.length > 0 ? (
                  <div>
                    <div style={styles.clearanceInfo}>
                      <span style={styles.clearanceLabel}>Clearance efectivo:</span>
                      <span style={styles.effectiveClearance}>{effectiveClearance}</span>
                    </div>
                    <div style={styles.tagContainer}>
                      {clearances.map((clearance, index) => (
                        <span 
                          key={index} 
                          style={{
                            ...styles.tag,
                            ...(clearance === effectiveClearance ? styles.effectiveTag : {})
                          }}
                        >
                          {clearance}
                        </span>
                      ))}
                    </div>
                  </div>
                ) : (
                  <span style={styles.noData}>No tiene clearances asignados</span>
                )}
              </div>
              
            </div>
          ) : (
            <div style={styles.noData}>
              <p>No se pudieron cargar los datos del usuario.</p>
            </div>
          )}
        </div>

        <div style={styles.footer}>
          <button
            onClick={onClose}
            style={styles.closeFooterButton}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "500px",
    maxHeight: "80vh",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    borderBottom: "1px solid #E5E5E5",
    backgroundColor: "#F8F9FA",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  icon: {
    color: "#00468B",
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "bold",
    color: "#00468B",
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "5px",
    borderRadius: "4px",
    color: "#666",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: "20px",
    maxHeight: "60vh",
    overflowY: "auto",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#333",
  },
  value: {
    fontSize: "16px",
    color: "#555",
    padding: "8px 12px",
    backgroundColor: "#F8F9FA",
    borderRadius: "4px",
    border: "1px solid #E5E5E5",
  },
  debugValue: {
    fontSize: "12px",
    color: "#666",
    padding: "8px 12px",
    backgroundColor: "#F0F0F0",
    borderRadius: "4px",
    border: "1px solid #E5E5E5",
    maxHeight: "200px",
    overflow: "auto",
    whiteSpace: "pre-wrap",
  },
  noData: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
  },
  footer: {
    padding: "20px",
    borderTop: "1px solid #E5E5E5",
    backgroundColor: "#F8F9FA",
    display: "flex",
    justifyContent: "flex-end",
  },
  closeFooterButton: {
    backgroundColor: "#00468B",
    color: "#FFFFFF",
    border: "none",
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
  },
  section: {
    marginTop: "20px",
    padding: "15px",
    backgroundColor: "#F8F9FA",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
  },
  sectionIcon: {
    marginRight: "8px",
    fontSize: "18px",
    color: "#00468B",
  },
  sectionTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "bold",
    color: "#00468B",
  },
  tagContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  tag: {
    display: "inline-block",
    padding: "4px 12px",
    backgroundColor: "#E5E7EB",
    color: "#374151",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "500",
    border: "1px solid #D1D5DB",
  },
  effectiveTag: {
    backgroundColor: "#00468B",
    color: "#FFFFFF",
    border: "1px solid #00468B",
    fontWeight: "bold",
  },
  clearanceInfo: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    padding: "8px 12px",
    backgroundColor: "#FFFFFF",
    borderRadius: "6px",
    border: "1px solid #D1D5DB",
  },
  clearanceLabel: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#374151",
    marginRight: "8px",
  },
  effectiveClearance: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#00468B",
    padding: "2px 8px",
    backgroundColor: "#E0F2FE",
    borderRadius: "4px",
  },
};

export default UserDataModal;
